<div class="clickable-text" (click)="onClick()">
  <wm-common-text [data]="{ text: text }"></wm-common-text>
</div>
